/**
 * BLOCK: FAQ
 */
import styling from './styling';
import React, { useEffect, useRef, lazy, Suspense } from 'react';
import lazyLoader from '@Controls/lazy-loader';
import { compose } from '@wordpress/compose';
import { select, dispatch, withSelect } from '@wordpress/data';

const Settings = lazy(() =>
	import(/* webpackChunkName: "chunks/faq/settings" */ './settings')
);
const Render = lazy(() =>
	import(/* webpackChunkName: "chunks/faq/render" */ './render')
);

const WPSPFaqEdit = (props) => {
	const prevStateRef = useRef(null);
	useEffect(() => {
		const { setAttributes } = props;

		// Assigning block_id in the attribute.
		setAttributes({ block_id: props.clientId.substr(0, 8) });

		setAttributes({
			schema: JSON.stringify(props.schemaJsonData),
		});
		// Pushing Style tag for this block css.
		const $style = document.createElement('style');
		$style.setAttribute(
			'id',
			'wpsp-style-faq-' + props.clientId.substr(0, 8)
		);
		document.head.appendChild($style);
		prevStateRef.current = props.schemaJsonData;
	}, []);

	useEffect(() => {
		const element = document.getElementById(
			'wpsp-style-faq-' + props.clientId.substr(0, 8)
		);

		if (null !== element && undefined !== element) {
			element.innerHTML = styling(props);
		}
	}, [props.attributes, props.clientId]);

	useEffect(() => {
		const getChildBlocks = select('core/block-editor').getBlocks(
			props.clientId
		);

		getChildBlocks.forEach((faqChild) => {
			dispatch('core/block-editor').updateBlockAttributes(
				faqChild.clientId,
				{ headingTag: props.attributes.headingTag }
			);
		});
	}, [props.attributes.headingTag, props.clientId]);

	useEffect(() => {
		if (
			JSON.stringify(props.schemaJsonData) !==
			JSON.stringify(prevStateRef.current)
		) {
			props.setAttributes({
				schema: JSON.stringify(props.schemaJsonData),
			});

			prevStateRef.current = props.schemaJsonData;
		}
	}, [props.schemaJsonData]);

	return (
		<Suspense fallback={lazyLoader()}>
			<Render parentProps={props} />
			<Settings parentProps={props} />
		</Suspense>
	);
};

export default compose(
	/* eslint-disable */
	withSelect((select, ownProps) => {
		/* eslint-enable */
		const pageUrl = select('core/editor').getPermalink();
		const jsonData = {
			'@context': 'https://schema.org',
			'@type': 'FAQPage',
			'@id': pageUrl,
			mainEntity: [],
		};
		const faqChildBlocks = select('core/block-editor').getBlocks(
			ownProps.clientId
		);

		faqChildBlocks.forEach((faqChild, key) => {
			jsonData.mainEntity[key] = {
				'@type': 'Question',
				name: faqChild.attributes.question,
				acceptedAnswer: {
					'@type': 'Answer',
					text: faqChild.attributes.answer,
				},
			};
		});

		return {
			schemaJsonData: jsonData,
		};
	})
)(WPSPFaqEdit);
